var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47912 10.8334C9.22579 10.8334 8.99746 10.68 8.90079 10.445L7.91662 8.0392L6.93246 10.445C6.83412 10.6867 6.58996 10.8509 6.33579 10.8334C6.07496 10.8259 5.84662 10.6575 5.76246 10.4109L4.19996 5.82754C4.08829 5.50004 4.26329 5.14504 4.58996 5.03337C4.91746 4.9217 5.27162 5.09754 5.38329 5.42337L6.40746 8.42754L7.33829 6.15254C7.52996 5.68337 8.30329 5.68337 8.49579 6.15254L9.42662 8.42754L10.4508 5.42337C10.5616 5.09754 10.9166 4.9217 11.2441 5.03337C11.5708 5.14504 11.7458 5.50004 11.6341 5.8267L10.0716 10.41C9.98662 10.6567 9.75829 10.825 9.49746 10.8334C9.49162 10.8334 9.48579 10.8334 9.47912 10.8334Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 15.8333C3.55167 15.8333 0 12.2817 0 7.91667C0 3.55167 3.55167 0 7.91667 0C12.2817 0 15.8333 3.55167 15.8333 7.91667C15.8333 12.2817 12.2817 15.8333 7.91667 15.8333ZM7.91667 1.25C4.24083 1.25 1.25 4.24083 1.25 7.91667C1.25 11.5925 4.24083 14.5833 7.91667 14.5833C11.5925 14.5833 14.5833 11.5925 14.5833 7.91667C14.5833 4.24083 11.5925 1.25 7.91667 1.25Z",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3749 19.9998C19.2149 19.9998 19.0549 19.9389 18.9332 19.8164L12.8416 13.7248C12.5974 13.4806 12.5974 13.0848 12.8416 12.8406C13.0857 12.5964 13.4816 12.5964 13.7257 12.8406L19.8174 18.9323C20.0616 19.1764 20.0616 19.5723 19.8174 19.8164C19.6949 19.9389 19.5349 19.9998 19.3749 19.9998Z",
    fill: "#676767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.03616360eb75d015205fa81187e917b9.svg";
export { ForwardRef as ReactComponent };